import { zenSigleton } from '@zenlayer/portal-utils';
import { EventEmitter } from '@zenlayer/zen-design/esm/_util/eventEmitter';
export const emitter = new EventEmitter();
const detailDrawerSig = {
    open: (opts) => {
        emitter.emit('open-drawer', opts);
    },
    close: () => {
        emitter.emit('close-drawer');
    },
    setRoutes: (opts) => {
        emitter.emit('set-routes', opts);
    },
    setCustomBreadCrumbs: (data) => {
        emitter.emit('set-custom-bread', data);
    },
};
zenSigleton.regist('detailDrawer', detailDrawerSig, { silent: true });
export const setDetailRoutes = (routeOpts) => {
    const detailDrawer = zenSigleton.get('detailDrawer');
    detailDrawer.setRoutes(routeOpts);
};
export const setCustomBreadCrumbs = (customBreads) => {
    const detailDrawer = zenSigleton.get('detailDrawer');
    detailDrawer.setCustomBreadCrumbs(customBreads);
};
